import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id 8408CE08-26C2-49B9-95CE-C5A9AAF4455E
 * name polaroid
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/polaroid.svg
 * tags
 */
export const PolaroidIcon = createSvgIcon(<><path d="M6,3H18A2,2 0 0,1 20,5V19A2,2 0 0,1 18,21H6A2,2 0 0,1 4,19V5A2,2 0 0,1 6,3M6,5V17H18V5H6Z" /></>, 'PolaroidIcon');
export default PolaroidIcon